/*
 * section-header-scroll.js
 * Scroll-driven header behaviors (Slice 3 Phase 3).
 * Conditionally loaded by sections/header.liquid only when at least one
 * scroll behavior is active: sticky (section or row), transparent-over-
 * hero on homepage, or any row opts into hide-when-scrolled.
 *
 * Toggles (all adapted to Phase 1 attribute/class names — Option B):
 *   .section-header.is-sticky         — scrolled past sticky engagement threshold (>0)
 *   .section-header.is-scrolled       — scrolled past the header's own height
 *   .section-header.is-scrolled-down  — last scroll delta was downward
 *   .header-row.is-scrolled-past      — row with hide-when-scrolled crossed threshold (one-way)
 *
 * Transparent-over-hero is handled entirely in CSS via `:not(.is-scrolled)`
 * on the homepage-enabled header. JS just maintains the `.is-scrolled` class;
 * CSS variable overrides and absolute positioning do the rest.
 *
 * Rule J9: IIFE bind-guard, single document-level scroll listener, rAF-throttled.
 * Rule J10: listens to shopify:section:load for customizer re-init.
 * prefers-reduced-motion handled in CSS — no JS branching.
 */
(function () {
  if (window.theme && window.theme.sectionHeaderScrollBound) return;
  window.theme = window.theme || {};
  window.theme.sectionHeaderScrollBound = true;

  var SECTION_SELECTOR = '.section-header';
  var IS_STICKY = 'is-sticky';
  var IS_SCROLLED = 'is-scrolled';
  var IS_SCROLLED_DOWN = 'is-scrolled-down';
  var IS_SCROLLED_PAST = 'is-scrolled-past';
  var STICKY_ENGAGE_PX = 1;

  var rafHandle = null;
  var lastY = 0;
  var headerHeight = 0;
  var sectionEl = null;

  function acquire() {
    sectionEl = document.querySelector(SECTION_SELECTOR);
    if (!sectionEl) return false;
    headerHeight = sectionEl.offsetHeight || 0;
    return true;
  }

  function apply() {
    rafHandle = null;
    if (!sectionEl) return;

    var y = window.pageYOffset || window.scrollY || 0;
    if (y < 0) y = 0;

    var isSticky = y > STICKY_ENGAGE_PX;
    var isScrolled = headerHeight > 0 ? y > headerHeight : y > STICKY_ENGAGE_PX;
    var dirDown = y > lastY && y > 0;

    sectionEl.classList.toggle(IS_STICKY, isSticky);
    sectionEl.classList.toggle(IS_SCROLLED, isScrolled);
    sectionEl.classList.toggle(IS_SCROLLED_DOWN, dirDown);

    var rows = sectionEl.querySelectorAll('.header-row');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (row.getAttribute('data-hide-when-scrolled') === 'true' && isScrolled) {
        row.classList.add(IS_SCROLLED_PAST);
      }
    }

    lastY = y;
  }

  function onScroll() {
    if (rafHandle != null) return;
    rafHandle = requestAnimationFrame(apply);
  }

  function onResize() {
    if (!sectionEl) return;
    headerHeight = sectionEl.offsetHeight || 0;
    onScroll();
  }

  function init() {
    if (!acquire()) return;
    lastY = window.pageYOffset || window.scrollY || 0;
    apply();
  }

  function onSectionLoad(e) {
    var id = e && e.detail && e.detail.sectionId;
    if (!id) return;
    var target = document.querySelector(SECTION_SELECTOR + '[data-section-id="' + id + '"]');
    if (!target) return;
    sectionEl = target;
    headerHeight = sectionEl.offsetHeight || 0;
    lastY = window.pageYOffset || window.scrollY || 0;
    apply();
  }

  document.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize);
  document.addEventListener('shopify:section:load', onSectionLoad);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
